import { Link } from "react-router-dom";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden border-t border-[#c9a04b]/30 bg-charcoal/95 backdrop-blur-md p-3"
    >
      <Link to="/book" className="btn-primary w-full !py-3.5">
        Book a Session
      </Link>
    </div>
  );
}
